<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            class="mb-0  "
          >
            <autocomplete
              v-model="total"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('total')"
              :value="total"
              type="total"
            />
          </v-col>
          <v-col
            cols="12"
            class="mb-0  "
          >
            <v-text-field
              v-model="number"
              :label="$t('code')"
              height="20"
              dense
              outlined
              type="number"
              class="mb-1 dense"
            >
              <template v-slot:append>
                <div style="margin-top: 6px">
                  {{(total && total.group ? total.group.number : '')}}{{(total ? total.number : '')}}
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="kind"
              :label="$t('type')"
              :items="kindItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="type"
              :label="$t('nature')"
              :items="typeItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            class="mb-0"
          >
            <v-text-field
              v-model="name"
              :label="$t('name')"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            class="mb-0  "
          >
            <autocomplete
              v-model="system"
              :title="$t('systemLink')"
              :value="system"
              type="system"
              :data="JSON.stringify({type : 'given'})"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <description
              v-model="content"
              :outlined="true"
              type="sell"
            />
          </v-col>
          <v-col cols="12">
            <div class="d-flex">
              <v-checkbox
                v-model="status"
                :label="$t('status')"
                value="active"
              />
              <!--              <v-spacer />-->
              <v-checkbox
                v-model="tracking"
                :label="$t('tracking')"
                value="active"
                class="ms-4"
              />
              <v-checkbox
                v-model="some"
                :label="$t('some')"
                value="active"
                class="ms-4"
              />
            </div>
            <div class="d-flex">
              <v-checkbox
                v-model="currencyFeature"
                :label="$t('currencyFeature')"
                value="active"
              />
              <v-checkbox
                v-model="interpretable"
                :label="$t('interpretable')"
                value="active"
                class="ms-4"
                :disabled="!currencyFeature"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  import Description from '../../components/general/description/Description'
  export default {
    name: 'given',
    components: {
      Description,
      Snakbar,
      autocomplete: () => import('../../components/general/patial/autocomplete'),
    },
    mixins: [General],
    props: ['item', 'totalProp', 'getObject'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      tracking: false,
      render: false,
      isLoading: false,
      some: false,
      interpretable: false,
      currencyFeature: false,
      alert: false,
      kind: null,
      kindItems: null,
      system: null,
      number: null,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      type: null,
      content: null,
      typeItems: null,
      id: null,
      status: 'active',
      level: 'given',
      total: null,
      loading: false,
    }),
    watch: {
      item (item, oldItem) {
        this.set(item)
      },
      totalProp (item, oldItem) {
        this.total = item
      },
    },
    beforeMount () {
      this.typeItems = [
        {
          value: 'neutral',
          text: this.$t('neutral'),
        },
        {
          value: 'debtor',
          text: this.$t('debtor'),
        },
        {
          value: 'creditor',
          text: this.$t('creditor'),
        },
      ]
      this.kindItems = [
        {
          value: 'always',
          text: this.$t('always'),
        },
        {
          value: 'temporary',
          text: this.$t('temporary'),
        },
      ]
    },
    mounted () {
      this.set(this.item)
      if (this.totalProp) {
        this.total = this.totalProp
      }
    },
    methods: {
      set (item) {
        if (this.item) {
          this.id = this.item.id
          this.name = this.item.name
          this.number = this.item.number
          this.type = this.item.type
          this.total = this.item.total
          this.system = this.item.system
          this.content = this.item.content
          this.status = this.item.status
          this.kind = this.item.kind
          this.some = this.item.some
          this.interpretable = this.item.interpretable
          this.currencyFeature = this.item.currencyFeature
          this.tracking = this.item.tracking
        } else {
          this.id = null
          this.name = null
          this.number = null
          this.type = null
          this.system = null
          this.total = this.totalProp
          this.content = null
          this.status = 'active'
          this.kind = null
          this.some = false
          this.interpretable = false
          this.currencyFeature = false
          this.tracking = false
        }
      },
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'coding', app.$data)
          .then(res => {
            app.name = null
            app.type = null
            app.number = null
            app.$emit('return', res.data.data)
            app.$emit('close')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'coding/' + this.id, this.$data)
          .then(res => {
            app.name = null
            app.type = null
            app.number = null
            app.$emit('close')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
